module.exports = __webpack_public_path__ + "assets/img/two.834aaa9e.png";